'use client';

import { useCart } from '@/app/lib/papa/cardapio/cart-context';
import './cart-bar.css';
import { ShoppingBagOutlined as ShoppingBagIcon, KeyboardArrowUp as ArrowUpIcon } from '@mui/icons-material';

function formatCurrency(value: number) {
    return 'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function CartBar({ onOpenDrawer }: { onOpenDrawer?: () => void }) {
    const { totalItems, totalPrice } = useCart();

    if (totalItems === 0) {
        return null;
    }

    return (
        <div 
            onClick={onOpenDrawer}
            className="cart-bar cursor-pointer select-none transition-transform hover:-translate-y-0.5"
            role="button"
            tabIndex={0}
            title="Clique para ver o resumo do carrinho"
        >
            <div className="cart-bar-info flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center text-white">
                    <ShoppingBagIcon fontSize="small" />
                </div>
                <div className="flex flex-col">
                    <span className="text-xs opacity-90 font-medium">{totalItems} {totalItems > 1 ? 'itens adicionados' : 'item adicionado'}</span>
                    <span className="text-sm font-bold font-mono">{formatCurrency(totalPrice)}</span>
                </div>
            </div>

            <button 
                type="button" 
                onClick={(e) => {
                    e.stopPropagation();
                    if (onOpenDrawer) onOpenDrawer();
                }}
                className="cart-bar-button flex items-center gap-1 cursor-pointer"
            >
                <span>Ver sacola</span>
                <ArrowUpIcon fontSize="small" />
            </button>
        </div>
    );
}

